module.exports = __webpack_public_path__ + "img/puff_green.34b0fc27.png";